export default __webpack_public_path__ + "static/media/Montserrat-ExtraBold.1944c8d1.ttf";